import moment from "moment";
import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../api/firebase/references";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";

/**
 * Fetches GI (Get Info) screenshot data from Firestore for today's date.
 *
 * @param giInfoPath - Determines which Firestore path to use ("api" for the API-based path,
 *   any other value for the default path). Should be read from Redux before calling.
 * @returns Object containing versions data and total unique orders stored.
 */
const getGiInfo = async (giInfoPath?: string) => {
  try {
    const organization = getOrgIdForFetchExternalWorklist();
    const date = moment().format("YYYY-MM-DD");
    const generatedFirestorePath =
      giInfoPath === "api"
        ? FirestoreDocumentReference.giInfoPathViaApi(organization, date)
        : FirestoreDocumentReference.giInfoPath(organization, date);
    const response = await FirestoreService.getDocument(generatedFirestorePath);
    const responseData = response as any;
    return {
      versions: responseData?.versions || {},
      total_unique_orders_stored: responseData?.total_unique_orders_stored || 0,
    };
  } catch (error) {
    console.error(error);
    return {
      versions: {},
      total_unique_orders_stored: 0,
    };
  }
};

export default getGiInfo;
